<template>
    <h1 class="circle-slider-text">
        <span v-html="computedTitle"></span>

        <span v-if="activeDomain !== 'nexdrive_co_uk'" :class="`current-step-${currentStep}`" class="emphasize period-text">{{ timePeriod }}</span>
    </h1>
</template>


<script>
import {gsap} from "gsap";

export default {
    name: "CircleSliderText",

    props: ['circleSliderText', 'activeDomain'],

    data() {
        return {
            currentStep: 1,

            timePeriod: null,

            periods: {
                1: window.Drupal.t('2 years'),
                2: window.Drupal.t('1 year'),
                3: window.Drupal.t('1 month'),
                4: window.Drupal.t('1 week'),
                5: window.Drupal.t('1 day'),
            },

            tl: gsap.timeline({paused: true}),
        }
    },

    computed: {
        computedTitle() {
            if (_.isEmpty(this.circleSliderText)) {
                return window.Drupal.t('How many EV<br> and hybrid customers<br> can you<br> help in<br>');
            }

            return this.circleSliderText;
        }
    },

    created() {
        if (this.activeDomain === 'nexdrive_de') {
            this.periods = {
                1: '2022',
                2: '2023',
                3: '2024',
                4: '2025',
                5: '2026',
            }
        }

        this.timePeriod = this.periods[1];
    },

    mounted() {
        window.eventBus.$on('circle-slider-step', (payload) => this.currentStep = payload);

        this.tl.to(
            '.period-text',
            {
                autoAlpha: 0,
                duration: .7,
                onComplete: () => this.timePeriod = this.periods[this.currentStep]
            }
        );

        this.tl.to(
            '.period-text',
            {
                autoAlpha: 1,
                duration: .7
            }
        );
    },

    watch: {
        currentStep() {
            this.tl.restart();
        }
    }
}
</script>
